import fetch from 'node-fetch';
import { createConfig } from '../../config';

export const getNavigation = async ({
  id,
  depth = 3,
  subset = 'MOBILE_WEB,FLYOUT',
  queryParams = '',
  exp = '',
} = {}) => {
  const { urls } = createConfig();
  const idUrl = id ? `/${id}` : '';
  let params = queryParams ? queryParams.replace(/^\?/, '') + '&' : '';
  params += `depth=${depth}&subset=${subset}`;
  if (exp) {
    params += `&experiments=${encodeURIComponent(exp)}`;
  }
  const uri = `${urls.base}/header/api/navigation${idUrl}?${params}`;
  const res = await fetch(uri, { credentials: 'include' });
  const json = await res.json();

  if (res.status !== 200) {
    return { error: json };
  }
  return json;
};
